$(function () {
    const reCaptchaSiteKey = $.p("recaptchaSiteKey", "contact");

    // reCaptcha Plugin
    $("form[name='contact']").reCaptchaPlugin({
        reCaptchaSiteKey: reCaptchaSiteKey,
        reCaptchaAction: "contact",
        submitButton: $("button[type='submit']")
    });
});

//# sourceMappingURL=contact.js.map
